module.exports = __webpack_public_path__ + "static/media/32.33cdd904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/32.jpg
// module id = 978
// module chunks = 0